import React from "react";
import { Link } from "react-router-dom";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import Footer from "../Header & Footer/kfooter";

const SomaliaLandingPage = () => (
  <div className="min-h-screen bg-white text-gray-900">
    <Konn3ctHeader />
    <main className="pt-20">
      <section className="max-w-7xl mx-auto px-6 py-20 lg:py-28 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#1A4699]">
            Konn3ct Somalia
          </p>
          <h1 className="mt-4 text-5xl lg:text-6xl font-black leading-tight">
            Connecting Somalia without boundaries.
          </h1>
          <p className="mt-6 text-lg leading-8 text-gray-600 max-w-xl">
            A seamless Konn3ct video meeting and collaboration experience designed for Somalia.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="https://dashboard.konn3ct.ng/register"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-[#1A4699] px-6 py-3 font-semibold text-white hover:bg-blue-800"
            >
              Get started free
            </a>
            <Link
              to="/events"
              className="rounded-full border border-gray-300 px-6 py-3 font-semibold text-gray-800 hover:bg-gray-50"
            >
              Explore events
            </Link>
          </div>
        </div>

        <div className="rounded-3xl bg-gradient-to-br from-blue-50 via-white to-green-50 border border-blue-100 p-8 min-h-[360px] flex items-center justify-center">
          <div className="text-center">
            <div className="text-7xl font-black text-[#1A4699]">K3</div>
            <p className="mt-4 text-gray-500">Meet · Connect · Collaborate · Grow</p>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 border-y border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-6">
          {[
            ["Meet freely", "Reliable meetings for individuals, teams, institutions and communities."],
            ["Host events", "Run public and paid events with Konn3ct registration and checkout flows."],
            ["Work across devices", "A multi-platform experience built for web, mobile and diverse network conditions."],
          ].map(([title, body]) => (
            <div key={title} className="rounded-2xl bg-white border border-gray-100 p-6">
              <h2 className="text-lg font-bold">{title}</h2>
              <p className="mt-2 text-sm leading-6 text-gray-600">{body}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default SomaliaLandingPage;
